var moduleMap = {
	"./DefaultHome": () => {
		return Promise.all([__webpack_require__.e(804), __webpack_require__.e(571)]).then(() => (() => ((__webpack_require__(55186)))));
	},
	"./DefaultPDP": () => {
		return Promise.all([__webpack_require__.e(804), __webpack_require__.e(449)]).then(() => (() => ((__webpack_require__(63148)))));
	},
	"./DefaultHeader": () => {
		return Promise.all([__webpack_require__.e(804), __webpack_require__.e(85)]).then(() => (() => ((__webpack_require__(61480)))));
	},
	"./DefaultFooter": () => {
		return Promise.all([__webpack_require__.e(804), __webpack_require__.e(26)]).then(() => (() => ((__webpack_require__(28499)))));
	},
	"./DefaultAllProducts": () => {
		return Promise.all([__webpack_require__.e(804), __webpack_require__.e(859)]).then(() => (() => ((__webpack_require__(86266)))));
	},
	"./DefaultFeaturedProducts": () => {
		return Promise.all([__webpack_require__.e(804), __webpack_require__.e(570)]).then(() => (() => ((__webpack_require__(27707)))));
	},
	"./DefaultSearchProducts": () => {
		return Promise.all([__webpack_require__.e(804), __webpack_require__.e(23)]).then(() => (() => ((__webpack_require__(21822)))));
	},
	"./DefaultCategoriesProductsListing": () => {
		return Promise.all([__webpack_require__.e(804), __webpack_require__.e(939)]).then(() => (() => ((__webpack_require__(61090)))));
	},
	"./DefaultCollectionsProductsListing": () => {
		return Promise.all([__webpack_require__.e(804), __webpack_require__.e(768)]).then(() => (() => ((__webpack_require__(45749)))));
	},
	"./DefaultHtmlCustomPage": () => {
		return Promise.all([__webpack_require__.e(804), __webpack_require__.e(498)]).then(() => (() => ((__webpack_require__(40171)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});